const SSRSTRUCTURE = {
  possibleStates: [
    {
      id: 1,
      state: "Created",
      actions: [
        {
          index: 1,
          name: "Send for approval",
        },
      ],
    },
    {
      id: 2,
      state: "Waiting for approval",
      actions: [
        {
          index: 0,
          name: "Reset to draft",
        },
        {
          index: 1,
          name: "Approve",
        },
      ],
    },
    {
      id: 3,
      state: "Approved",
      actions: [
        {
          index: 0,
          name: "Reset to draft",
        },
        {
          index: 1,
          name: "generate actions",
        },
      ],
    },
  ],
  date: "July 1, 2023",
  reportState: "Created",
  assigned_to: [{ name: "John", id: "1" }],
  editors: [],
  watchers: [],
  programId: "",
  programName: "Engineering",
  institutionName: "Upper State",
  location: "Upper State, Anystate",
  BACKGROUNDINFORMATION: {
    ContactInformation: {
      name: "Garrett H. Aloevera",
      department: "Department of Engineering",
      college: "College of Natural Science and Engineering",
      university: "Upper State University",
      address: "Upper State, Anystate",
      phone: "(999) 123-4567",
      email: "dean@upperstate.edu",
      fax: "(999) 222-4567",
    },
    // major changes are the actions (with "high priority", and whose states are "done") taken to adress feedback of last general review
    ProgramHistory: {
      lastReviewDate: "October 5-7, 2019",
      majorChanges: [],
      history:
        "The Engineering program at Upper State University is a general engineering program that serves the regional economy of Northern Upper State, Anystate, USA. The program has been in existence since 1980. Significant changes to the program include the offering of two additional options as of Fall, 2018 – Chemical Engineering and Electrical Engineering. These have been added to the existing Civil Engineering and Mechanical Engineering options bringing the number of options to four.",
      description: `
        <p>The last general review was held October 5-7, 2015. Significant changes to the program since the last visit include the hiring of eight new full-time engineering faculty members. No significant changes have been made to the curriculum. Changes in response to a shortcoming identified in the previous visit are described in Section G below.</p><br></br>
        `,
    },
    // options are propably the fields
    Options: {
      options: ["civil", "chemical", "electrical", "mechanical"],
      description: `<p>The degree conferred is the B.S. in Engineering with options in one of four areas: civil, chemical, electrical, and mechanical. The option is noted on the student transcript, but is not indicated on the line designating the degree conferred. Options are not required.</p>`,
    },
    ProgramDeliveryModes: {
      modes: [
        "days",
        "evenings",
        "traditional lecture/laboratory",
        "cooperative education",
      ],
      description: `<p>The Engineering program is offered in the day mode with courses offered in traditional lecture/laboratory style. Occasionally a course is offered in the evening. There is no significant distance education or web-based component in the program. All students are encouraged to spend a minimum of one semester in a cooperative education or internship position.</p>`,
    },
    ProgramLocations: {
      locations: [],
      description: `<p>All elements of the program are offered on the Upper State University campus. No portion of the program is offered elsewhere.</p>`,
    },
    PublicDisclosure: {
      publicDisclosure: "",
      description: `<p>Program Educational Objectives, Student Outcomes, and student enrollment and graduation data are available on the Upper State Public Website at www.upperstate.edu/abet.</p>`,
    },
    PreviousEvaluations: {
      //evaluations include information about the dates, the concerns, and the actions (with dates) taken to address them
      feedback: [
        {
          id: 1,
          subject: "Curriculum Breadth",
          descripton:
            "The curriculum provides strong coverage of core engineering concepts, but there is limited exposure to emerging technologies such as artificial intelligence and data analytics, which are increasingly important in modern engineering practice.",
          type: "concern",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "1",
              feedbackId: "1",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "2",
              feedbackId: "1",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "3",
              feedbackId: "1",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 2,
          subject: "Outcomes Assessment",
          descripton:
            "The program has not adequately demonstrated a structured and comprehensive approach to assessing student outcomes. There is no clear evidence that student performance is systematically evaluated against the stated program outcomes.",
          type: "deficiency",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "4",
              feedbackId: "2",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "5",
              feedbackId: "2",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "6",
              feedbackId: "2",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 3,
          subject: "Advising and Mentorship",
          descripton:
            "While academic advising is available, there is a weakness in the advising process, as students have expressed concerns about the lack of personalized guidance and mentorship to help them navigate their academic and career pathways.",
          type: "weakness",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "7",
              feedbackId: "3",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "8",
              feedbackId: "3",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "9",
              feedbackId: "3",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 4,
          subject: "Strong Industry Partnerships",
          descripton:
            "The program has established strong partnerships with local industries, offering students valuable internship opportunities and industry-sponsored projects that enhance their professional readiness.",
          type: "strength",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          //feedback of type strength does not have actions associated with it
          actions: [],
        },
        {
          id: 5,
          subject: "Expand Emerging Technology Offerings",
          descripton:
            "To keep pace with industry trends, the program should consider introducing electives or modules focused on emerging areas such as artificial intelligence, robotics, and renewable energy.",
          type: "recommendation for improvement",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "13",
              feedbackId: "5",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "14",
              feedbackId: "5",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "15",
              feedbackId: "5",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
      ],
      description: "",
    },
  },
  CRITERION1_STUDENTS: {
    StudentAdmissions: {
      // Progeram admission requirements
      studentAdmissionRequirements: [
        "Cumulative high school grade point average of 2.5 or higher on a 4.0-point scale",
        "Ranked in the top half of high school graduating class",
        "SAT composite score of at least 950 or ACT composite of 20 or above.",
      ],
      description: `<p>All Upper-State University (USU) first-year engineering students are admitted and dually enrolled in the Undergraduate University Division (UUD) and the College of Natural Science and Engineering (CNSE). </p><br></br>
        <p>Exceptions to the above standards may be made on an individual basis and are reviewed by the Admissions Office. Those who are admitted on an exception basis may be required to take supplementary work during their first year at Upper State U.niversity. Credits in supplementary courses are not applied to graduation requirements.</p>
        `,
    },
    EvaluatingStudentPerformance: {
      // All Courses prerequisites
      prerequisites: [
        {
          key: "1",
          title: "Finance1",
          children: [
            {
              key: "11",
              title:
                "Students must have more than a 2.00 cumulative grade point average.",
            },
            {
              key: "12",
              title:
                "Students must not earn a 1.0 in one term, with six or more credits.",
            },
          ],
        },
        {
          key: "2",
          title: "Finance2",
          children: [
            {
              key: "21",
              title:
                "Students must have more than a 1.00 cumulative grade point average. ",
            },
            {
              key: "22",
              title:
                "Students must not earn a 1.5 in one term, with five or more credits.",
            },
          ],
        },
      ],

      description: `<p>Two files are maintained for each upper-level student, one in the associate dean’s office and one in the advisor’s office. These electronic files contain all grade sheets, transfer credit evaluations, course schedule planning sheets, records of advisor conferences, etc. </p><br></br>
        <p><strong>Databases:</strong> Advisors and students are able to assess student progress toward the degree using a web-based Degree Auditing System (DAS). DAS is also able to produce an unofficial transcript or technical grade point average calculation report for students. For advisors, support staff, and administrators, DAS allows queries of student data using a variety of parameters and data reporting and sorting choices. DAS obtains its data from the university’s mainframe- based Student Information Report System (SIRS), which houses all course- and student-related data for all USU students and courses (up to 30 years back). All academic advisors, authorized staff, and administrators have access to all SIRS information.</p><br></br>
        <p>The course registration system interfaces with SIRS and DAS to ensure that prerequisites are met. A student is not permitted to register for a course unless all prerequisites identified in SIRS are met or the instructor teaching the course approves an override of the system.</p><br></br>
        <p>Academic advisors work closely with faculty and the Office of Student Placement to connect students to co-curricular opportunities such as cooperative education, internships, and study abroad. These students often have special scheduling considerations, and academic advisors help students devise a plan to complete degree requirements in a timely manner.</p>`,
    },
    TransferStudentsAndTransferCourses: {
      transferStudentsAcceptanceRequirements: [
        "Completion of at least 56 semester credits.",
        "Completion of at least Calculus I and II, Chemistry I and II, Physics I and II, and a computing course. Students with more course work completed than the minimum are given priority.",
        "A minimum grade point average of 3.00 is required for consideration.  International students must have a 3.50 minimum grade point average.",
        "A maximum of 50 external transfer students per year may be admitted.",
      ],
      transferCreditAcceptanceRequirements: [],
      description: `<p>There are no formal articulation agreements with other institutions, with the exception of the Minority Advancement Program participants at Upper State Community College. Qualified students (10 per year maximum) continuing to meet the established requirements of this program are granted admission and scholarships to USU.</p>`,
    },
    AdvisingAndCareerGuidance: {
      // frequency: { times: 2, term: "year" },
      // // advisor can be program faculty, departmental, college or university advisor
      // advivisors: "program faculty",
      GuidanceAndOrientationProgramsForNewStudents:
        "Guidance and orientation programs for new students",
      StudentCounselingServices: "student counseling services",
      SpecialSupport: "special support",
      description: `<p>Student advising is conducted through the Office of the Associate Dean for Undergraduate Studies in the CNSE. In addition to its importance in career counseling, advising helps ensure that B.S. graduates have completed the curriculum of the engineering program. The core engineering curriculum and the electives are the key elements in meeting program educational objectives since U all   of the educational objectives are addressed and student outcomes are achieved through the curriculum. Specifically, the curriculum provides a thorough base of mathematics, physical science, computing foundations, laboratory experience, and applications experience which prepares students to apply engineering problem-solving principles to a variety of contemporary problems. In addition, the curriculum provides the general education necessary to identify the effect of design and implementation decisions in the broader societal context. The rigorous curriculum is the foundation to the graduate’s ability to function as a practicing professional or graduate student.</p><br></br>
      <p>The CNSE employs a professional full-time academic advisor for the engineering program. The advisor has a master’s degree and is a member of a professional advising association. Engineering advising is done separately from the other CNSE students, but the engineering advisor works closely with the 10 academic advisors for the other CNSE students. The CNSE Advising Coordinator and other CNSE advisors also assist with routine advising when needed. </p><br></br>
      <p>All students first meet their advisor at the required First-year Orientation Program before starting classes. Further advising is available upon request, but not mandatory, and students are ultimately responsible for planning their academic programs and meeting degree requirements.</p>
      `,
    },
    WorkInLieuOfCourses: {
      // work in lien of courses could include life experience, Advanced Placement, dual enrollment, test out, military experience
      // workExperience: [
      //   "life experience",
      //   "advanced Placement",
      //   "dual enrollment",
      //   "test out",
      //   "military experience",
      // ],
      // workExperienceCreditAwardingRequirements: [],
      WorkInLieuOfCourses: "",
      description: `<p>Upper State University Engineering students are encouraged to spend a minimum of one semester in one of the listed-above "work in lieu of courses" . The work experience is listed on the student transcript, but no credit or grade is assigned.</p>`,
    },
    GraduationRequirements: {
      programName: "Engineering",
      awardedDegreeName: "B.S. in Engineering",
      graduationRequirements: ["Students must attain 100 credits"],
      description: `<p>A senior audit is conducted in the semester after a CNSE student attains 100 credits. At that time, the student’s record is reviewed for progress toward the B.S. in Engineering degree, any transfer credits that still need to be evaluated, documentation of waivers (substitutions), and completion of electives. Students are not required to meet with the advisors, but are strongly encouraged by e-mail and phone messages, when necessary. When a student applies for graduation, the student record is reviewed by staff at several layers. The record is finally submitted for certification by the Associate Dean. Any degree deficiencies are reported to the Registrar’s Office.</p>`,
    },
    RecordsOfStudentWorkOrTranscripts: {
      transcriptsFiles: [],
      attachments: [],
      description: `<p>Transcripts from three May 2020 graduates are submitted along with this self-study report. Additional information concerning transfer credit evaluation is attached to the transcript. The degree, degree status, major, and minor are specified in the transcript header on the first page</p>`,
    },
    Analysis: {
      feedback: [
        {
          id: 1,
          subject: "Curriculum Breadth",
          descripton:
            "The curriculum provides strong coverage of core engineering concepts, but there is limited exposure to emerging technologies such as artificial intelligence and data analytics, which are increasingly important in modern engineering practice.",
          type: "concern",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "1",
              feedbackId: "1",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "2",
              feedbackId: "1",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "3",
              feedbackId: "1",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 2,
          subject: "Outcomes Assessment",
          descripton:
            "The program has not adequately demonstrated a structured and comprehensive approach to assessing student outcomes. There is no clear evidence that student performance is systematically evaluated against the stated program outcomes.",
          type: "deficiency",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "4",
              feedbackId: "2",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "5",
              feedbackId: "2",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "6",
              feedbackId: "2",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 3,
          subject: "Advising and Mentorship",
          descripton:
            "While academic advising is available, there is a weakness in the advising process, as students have expressed concerns about the lack of personalized guidance and mentorship to help them navigate their academic and career pathways.",
          type: "weakness",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "7",
              feedbackId: "3",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "8",
              feedbackId: "3",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "9",
              feedbackId: "3",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 4,
          subject: "Strong Industry Partnerships",
          descripton:
            "The program has established strong partnerships with local industries, offering students valuable internship opportunities and industry-sponsored projects that enhance their professional readiness.",
          type: "strength",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          //feedback of type strength does not have actions associated with it
          actions: [],
        },
        {
          id: 5,
          subject: "Expand Emerging Technology Offerings",
          descripton:
            "To keep pace with industry trends, the program should consider introducing electives or modules focused on emerging areas such as artificial intelligence, robotics, and renewable energy.",
          type: "recommendation for improvement",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "13",
              feedbackId: "5",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "14",
              feedbackId: "5",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "15",
              feedbackId: "5",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
      ],
    },
  },
  CRITERION2_PROGRAMEDUCATIONALOBJECTIVES: {
    MissionStatement: {
      institutionMissionStatement: `In its 100-year history, Upper State University has been a leader in educating the people of this state. In continuation of this rich tradition, Upper State University maintains its commitment to advancing knowledge and serving a worldwide society. Upper State University is committed to providing access to quality education and expert knowledge, to promoting scholarship and problem solving to address the needs of a global society, to advancing diversity both on our campus and within the community, and to making people matter.`,
      collegeMissionStatement: `The CNSE will produce applied science, engineering, engineering technology, and computing graduates who are able to integrate theoretical knowledge and practical application as productive citizens in an ever-changing technological world. The CNSE graduate will have the skills to be a productive member of the community, to work in an interdisciplinary framework, and will have an appreciation of the effect of their work on the global society.`,
      programMissionStatement: ``,
      description: "",
    },
    ProgramEducationalObjectives: {
      PEOs: [
        "be effective in the design of engineering solutions and the practical application of engineering principles",
        "effectively lead, work, and communicate in cross-functional teams",
        "conduct themselves with high standards of ethics",
        "be successfully employed in an engineering or related field, or accepted into graduate programs",
        "expand their knowledge and capabilities through continuing education or other lifelong learning experiences",
        "serve their communities, whether locally, nationally, or globally.",
      ],
      publicDisclosure: "",
      programName: "Engineering",
      institutionName: "Upper State",
      description: `<p>The program educational objectives (PEOs) support the missions of the institution and of the college. The program educational objectives are published in our on-line undergraduate catalog (Hwww.upperstate.edu/ugcatalogH), in college brochures, in recruiting literature, and are posted in our building in various display cases. </p>`,
    },
    ConsistencyOfTheProgramEducationalObjectivesWithTheMissionOfTheInstitution:
      {
        description: `<p>If the program educational objectives are achieved then the program will have produced graduates who are successful professionals and also good citizens.  That is, the program will provide a quality education based on expert knowledge that enables its graduates to be successful problem solvers in a global society</p>`,
      },
    ProgramConstituencies: {
      constituencies: [
        "Engineering faculty",
        "current Engineering students",
        "alumni",
        "major donors and employers",
      ],
      description: `<p>Each of these constituencies is a stakeholder in the educational processes in the engineering program. The Engineering faculty has the academic responsibility for the curriculum and for education of the students. The program and curricula they administer is a major means of accomplishing all the program’s objectives. The engineering students are included as a program constituency because their input is valuable feedback for program improvement, many have had industrial experience, and they are the direct beneficiaries of an effective educational process. Alumni are the “products” and strong supporters of the academic program. Their careers demonstrate the accomplishment of the PEOs. Alumni often become the major donors who play advisory roles and provide financial support for scholarships and endowments that directly affect students in their education. Employers desire to hire well-educated undergraduate engineering students, and graduates who accomplish all the PEOs are a clear benefit to their employers. In summary, each of these constituencies has a vested interest in the success and continued improvement of the engineering program at Upper State University and the proper direction of the program through its educational objectives.</p>`,
    },
    ProcessForReviewOfTheProgramEducationalObjectives: {
      description: `<p>The overall process to determine and approve the current version of the program educational objectives (PEOs) began in the summer of 2018. Since our Engineering Advisory Council includes representation of several constituencies (alumni, employers, major donors) a meeting of the board was held to elicit a list of constituent needs. Based on this list, a first draft of the PEOs was presented in early fall by the Engineering Curriculum Committee—a representative body of faculty, advisors, and students. All Engineering faculty members were invited to edit the proposed PEOs; about 50 percent of the faculty responded, which is a good response level for the survey approach used in this exercise. The second draft was presented to the Engineering Advisory Council for additional comments. While on campus for the fall semester Career Fair (November 2018), ten representatives of major employers participated in a lunchtime focus group during which the PEOs were evaluated and discussed. Copies of the PEOs were distributed to the employer representatives about two weeks in advance of the focus group meeting. Given the input from all of these sources, the final version of the PEOs was approved by a unanimous vote of the engineering faculty in April 2019.</p><p><br></p><p>Since the initial development of our PEOs, they have been reevaluated each time the alumni survey is administered, during the annual Engineering Advisory Council meetings, in the last Engineering Curriculum Committee meeting of the academic year, as part of the senior exit interview, and biannually in employer focus groups. Whether the evaluation of PEOs suggests a need for their revision or not, the table below summarizes the scheduling of constituent input to PEOs.</p><p><br></p><table><tbody><tr><td style="width: 171px;"><p data-cellwidth="171px"><strong>Input Method</strong></p></td><td style="width: 171px;"><p data-cellwidth="171px"><strong>Schedule</strong></p></td><td style="width: 171px;"><p data-cellwidth="171px"><strong>Constituent</strong></p></td></tr><tr><td style="width: 171px;"><p data-cellwidth="171px">Alumni survey</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Every three years</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Alumni 2-5 years out</p><p data-cellwidth="171px"><br></p></td></tr><tr><td style="width: 171px;"><p data-cellwidth="171px">Employer focus group</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Every two years during Career Fair</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Employers (and recruiters); some are alumni</p><p data-cellwidth="171px"><br></p></td></tr><tr><td style="width: 171px;"><p data-cellwidth="171px">Senior exit interview</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Annually</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Students; retrospective discussion of PEOs and their intended career paths</p><p data-cellwidth="171px"><br></p></td></tr></tbody></table><p><br></p><p><br></p><p>The program’s ABET coordinator maintains a documentation of the review of PEOs as part of the continuous improvement process in a web-based database. The documentation includes minutes from Advisory Council and curriculum committee meetings, survey summaries, and notes from focus groups. A summary of the PEO review is also included in the assessment report. The coordinator, the chairperson, and the chair of the Curriculum Committee each have direct access to these files.</p><p>Since the last accreditation review in 2015, the changes in the table below have been proposed, discussed, and approved:</p><p><br></p><p><br></p><table><tbody><tr><td style="width: 133px;"><p data-cellwidth="133px"><strong>Modification</strong></p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px"><strong>Proposing Constituency</strong></p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px"><strong>Approval Date</strong></p><p data-cellwidth="171px"><br></p></td></tr><tr><td style="width: 133px;"><p data-cellwidth="133px">Expand first PEO to include practical application of engineering principles; add PEO on leadership and ability to function in cross-functional teams</p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px">Alumni; strongly supported by the Advisory Council</p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px">Spring, 2017</p><p data-cellwidth="171px"><br></p></td></tr><tr><td style="width: 133px;"><p data-cellwidth="133px">Add “global” to the list of communities in which our graduates will serve</p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px">Employers</p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px">Spring, 2019</p><p data-cellwidth="171px"><br></p></td></tr><tr><td style=""><p>Various grammatical and stylistic modifications</p><p><br></p></td><td style=""><p>Curriculum Committee</p><p data-cellwidth="133px"><br></p></td><td style=""><p>Various</p><p data-cellwidth="133px"><br></p></td></tr></tbody></table><p><br></p><p><br></p>`,
    },
    Analysis: {
      feedback: [
        {
          id: 1,
          subject: "Curriculum Breadth",
          descripton:
            "The curriculum provides strong coverage of core engineering concepts, but there is limited exposure to emerging technologies such as artificial intelligence and data analytics, which are increasingly important in modern engineering practice.",
          type: "concern",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "1",
              feedbackId: "1",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "2",
              feedbackId: "1",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "3",
              feedbackId: "1",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 2,
          subject: "Outcomes Assessment",
          descripton:
            "The program has not adequately demonstrated a structured and comprehensive approach to assessing student outcomes. There is no clear evidence that student performance is systematically evaluated against the stated program outcomes.",
          type: "deficiency",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "4",
              feedbackId: "2",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "5",
              feedbackId: "2",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "6",
              feedbackId: "2",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 3,
          subject: "Advising and Mentorship",
          descripton:
            "While academic advising is available, there is a weakness in the advising process, as students have expressed concerns about the lack of personalized guidance and mentorship to help them navigate their academic and career pathways.",
          type: "weakness",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "7",
              feedbackId: "3",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "8",
              feedbackId: "3",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "9",
              feedbackId: "3",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 4,
          subject: "Strong Industry Partnerships",
          descripton:
            "The program has established strong partnerships with local industries, offering students valuable internship opportunities and industry-sponsored projects that enhance their professional readiness.",
          type: "strength",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          //feedback of type strength does not have actions associated with it
          actions: [],
        },
        {
          id: 5,
          subject: "Expand Emerging Technology Offerings",
          descripton:
            "To keep pace with industry trends, the program should consider introducing electives or modules focused on emerging areas such as artificial intelligence, robotics, and renewable energy.",
          type: "recommendation for improvement",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "13",
              feedbackId: "5",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "14",
              feedbackId: "5",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "15",
              feedbackId: "5",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
      ],
    },
  },
  CRITERION3_STUDENTOUTCOMES: {
    ProcessForTheEstablishmentAndRevisionOfTheStudentOutcomes: {
      description: "",
    },
    StudentOutcomes: {
      PLOs: [

        "an ability to identify, formulate, and solve complex engineering problems by applying principles of engineering, science, and mathematics",
        "an ability to apply engineering design to produce solutions that meet specified needs with consideration of public health, safety, welfare, as well as global, cultural, social, environmental, and economic factors ",
        "an ability to communicate effectively with a range of audiences",
        "an ability to function effectively on a team whose members together provide leadership, create a collaborative and inclusive environment, establish goals, plan tasks, and meet objectives",
        "an ability to develop and conduct appropriate experimentation, analyze and interpret data, and use engineering judgment to draw conclusions",
        "an ability to recognize ethical and professional responsibilities in engineering situations and make informed judgments, which must consider the impact of engineering solutions in global, economic, environmental, and societal contexts",
        "an ability to acquire and apply new knowledge as needed, using appropriate learning strategies",
        "a willingness to assume leadership roles and responsibilities",
        // {
        //   program_SO:
        //     "an ability to identify, formulate, and solve complex engineering problems by applying principles of engineering, science, and mathematics",
        //   ABET_SO: "EAC C3 Student Outcome 3.1",
        // },
        // {
        //   program_SO:
        //     "an ability to apply engineering design to produce solutions that meet specified needs with consideration of public health, safety, welfare, as well as global, cultural, social, environmental, and economic factors ",

        //   ABET_SO: "EAC C3 Student Outcome 3.2",
        // },
        // {
        //   program_SO:
        //     "an ability to communicate effectively with a range of audiences",
        //   ABET_SO: "EAC C3 Student Outcome 3.3",
        // },
        // {
        //   program_SO:
        //     "an ability to function effectively on a team whose members together provide leadership, create a collaborative and inclusive environment, establish goals, plan tasks, and meet objectives",
        //   ABET_SO: "EAC C3 Student Outcome 3.4",
        // },
        // {
        //   program_SO:
        //     "an ability to develop and conduct appropriate experimentation, analyze and interpret data, and use engineering judgment to draw conclusions",
        //   ABET_SO: "EAC C3 Student Outcome 3.5",
        // },
        // {
        //   program_SO:
        //     "an ability to recognize ethical and professional responsibilities in engineering situations and make informed judgments, which must consider the impact of engineering solutions in global, economic, environmental, and societal contexts",
        //   ABET_SO: "EAC C3 Student Outcome 3.6",
        // },
        // {
        //   program_SO:
        //     "an ability to acquire and apply new knowledge as needed, using appropriate learning strategies",
        //   ABET_SO: "EAC C3 Student Outcome 3.7",
        // },
        // {
        //   program_SO:
        //     "a willingness to assume leadership roles and responsibilities",
        //   ABET_SO: "EAC C3 Student Outcome 3.7",
        // },
      ],
      // each PLO should have an array of appropriate General Criteria Student Outcomes, if the  PLO does not address any General Criteria, the list should be empty
      programName: "Engineering",
      publicDisclosure: "",
      description: `<p>The student outcomes are publicly available on our web site (www.upperstate.edu/abet) and published in our on-line undergraduate catalog (www.upperstate.edu/catalog), in college brochures, in recruiting literature, and are posted in our building in various display cases.</p>
      <br></br> <p>The eight student outcomes for the Engineering program at Upper State University are listed below. They encompass all the ABET EAC Criterion 3 outcomes. The ABET EAC Criterion 3 (EAC C3) student outcomes are noted parenthetically below each USU student outcome.  We have added an outcome related directly to leadership. We have also adopted the Engineering Criteria definition of outcomes as narrower statements that describe what students are expected to know or be able to do by the time of graduation from our program.</p>`,
    },
    RelationshipOfStudentOutcomesToProgramEducationalObjectives: {
      //a list of the PEOs codes
      PEOs: ["PEO1", "PEO2", "PEO3"],
      //the mapping array should follow the following format:
      PLOs_PEOs_mapping: [
        {
          PLO: "1. an ability to identify, formulate, and solve complex engineering problems by applying principles of engineering, science, and mathematics",
          PEO1: true,
          PEO2: false,
          PEO3: false,
        },
        {
          PLO: "2. an ability to apply engineering design to produce solutions that meet specified needs with consideration of public health, safety, welfare, as well as global, cultural, social, environmental, and economic factors",
          PEO1: false,
          PEO2: false,
          PEO3: false,
        },
        {
          PLO: "3. an ability to communicate effectively with a range of audiences",
          PEO1: true,
          PEO2: true,
          PEO3: false,
        },
        {
          PLO: "4. an ability to function effectively on a team whose members together provide leadership, create a collaborative and inclusive environment, establish goals, plan tasks, and meet objectives",
          PEO1: true,
          PEO2: false,
          PEO3: false,
        },
        {
          PLO: "5. an ability to develop and conduct appropriate experimentation, analyze and interpret data, and use engineering judgment to draw conclusions",
          PEO1: true,
          PEO2: false,
          PEO3: false,
        },
        {
          PLO: "6. an ability to recognize ethical and professional responsibilities in engineering situations and make informed judgments, which must consider the impact of engineering solutions in global, economic, environmental, and societal contexts",
          PEO1: false,
          PEO2: true,
          PEO3: false,
        },
        {
          PLO: "7. an ability to acquire and apply new knowledge as needed, using appropriate learning strategies",
          PEO1: true,
          PEO2: true,
          PEO3: true,
        },
        {
          PLO: "8. a willingness to assume leadership roles and responsibilities",
          PEO1: true,
          PEO2: false,
          PEO3: false,
        },
      ],
      PLOs_Indicators_mapping: [
        {
          PLO: "1. an ability to identify, formulate, and solve complex engineering problems by applying principles of engineering, science, and mathematics",
          indicators: [
            "Problem statement shows understanding of the problem",
            "Problem solution is appropriate and within reasonable constraints ",
            "Applies mathematical and/or science principles to achieve analytical or numerical solution to model equations",
            "Selects appropriate techniques and tools for a specific engineering task",
            "Compares results with results from alternative tools or techniques",
          ],
        },
        {
          PLO: "2. an ability to apply engineering design to produce solutions that meet specified needs with consideration of public health, safety, welfare, as well as global, cultural, social, environmental, and economic factors",
          indicators: [
            "Produces a clear and unambiguous needs statement in a design project",
            "Identifies constraints on the design problem, and establishes criteria for acceptability and desirability of solutions",
            "Evaluates and analyzes the economics of an engineering problem solution",
            "Uses risk analysis techniques to characterize and respond to risks in product or process design",
          ],
        },
        {
          PLO: "3. an ability to communicate effectively with a range of audiences",
          indicators: [
            "Writing conforms to appropriate technical style format appropriate to the audience",
            "Graphics used to enhance presentation",
          ],
        },
        {
          PLO: "4. an ability to function effectively on a team whose members together provide leadership, create a collaborative and inclusive environment, establish goals, plan tasks, and meet objectives",
          indicators: [
            "Fulfills appropriate roles to ensure team success",
            "Integrates input from all team members and makes decisions in relation to objective criteria",
            "Facilitates communication among teammates, asks for feedback and uses suggestions",
          ],
        },
        {
          PLO: "5. an ability to develop and conduct appropriate experimentation, analyze and interpret data, and use engineering judgment to draw conclusions",
          indicators: [
            "Observes good lab practice and operates instrumentation with ease",
            "Determines data that are appropriate to collect and selects appropriate equipment, protocols, etc. for measuring the appropriate variables to get required data",
            "Uses appropriate tools to analyze data and verifies and validates experimental results including the use of statistics to account for experimental error",
          ],
        },
        {
          PLO: "6. an ability to recognize ethical and professional responsibilities in engineering situations and make informed judgments, which must consider the impact of engineering solutions in global, economic, environmental, and societal contexts",
          indicators: [
            "Knows code of ethics for the discipline",
            "Evaluates conflicting/competing social values to make informed decisions about an engineering solution",
            "Identifies the environmental and social issues involved in an engineering solution and incorporates that sensitivity into the design process",
          ],
        },
        {
          PLO: "7. an ability to acquire and apply new knowledge as needed, using appropriate learning strategies",
          indicators: [
            "Expresses an awareness that education is continuous after graduation",
            "Able to find information relevant to problem solution without guidance",
          ],
        },
        {
          PLO: "8. a willingness to assume leadership roles and responsibilities",
          indicators: [
            "Expresses a willingness to take on leadership responsibility",
            "Demonstrates the ability to monitor team progress and make suggestions when needed",
            "Engages team members in problem solution",
          ],
        },
      ],
      description: "",
    },
    // check if we need to include the table for mapping performance indicators to PLOs
    Analysis: {
      feedback: [
        {
          id: 1,
          subject: "Curriculum Breadth",
          descripton:
            "The curriculum provides strong coverage of core engineering concepts, but there is limited exposure to emerging technologies such as artificial intelligence and data analytics, which are increasingly important in modern engineering practice.",
          type: "concern",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "1",
              feedbackId: "1",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "2",
              feedbackId: "1",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "3",
              feedbackId: "1",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 2,
          subject: "Outcomes Assessment",
          descripton:
            "The program has not adequately demonstrated a structured and comprehensive approach to assessing student outcomes. There is no clear evidence that student performance is systematically evaluated against the stated program outcomes.",
          type: "deficiency",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "4",
              feedbackId: "2",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "5",
              feedbackId: "2",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "6",
              feedbackId: "2",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 3,
          subject: "Advising and Mentorship",
          descripton:
            "While academic advising is available, there is a weakness in the advising process, as students have expressed concerns about the lack of personalized guidance and mentorship to help them navigate their academic and career pathways.",
          type: "weakness",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "7",
              feedbackId: "3",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "8",
              feedbackId: "3",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "9",
              feedbackId: "3",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 4,
          subject: "Strong Industry Partnerships",
          descripton:
            "The program has established strong partnerships with local industries, offering students valuable internship opportunities and industry-sponsored projects that enhance their professional readiness.",
          type: "strength",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          //feedback of type strength does not have actions associated with it
          actions: [],
        },
        {
          id: 5,
          subject: "Expand Emerging Technology Offerings",
          descripton:
            "To keep pace with industry trends, the program should consider introducing electives or modules focused on emerging areas such as artificial intelligence, robotics, and renewable energy.",
          type: "recommendation for improvement",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "13",
              feedbackId: "5",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "14",
              feedbackId: "5",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "15",
              feedbackId: "5",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
      ],
    },
  },
  CRITERION4_CONTINUOUSIMPROVEMENT: {
    StudentOutcomes: {
      // if assessment processes are the assessment methods
      assessmentMethods: [
        { assessmentMethod: "oral-exam", description: "" },
        { assessmentMethod: "focus-group", description: "" },
      ],
      assessmentFrequency: "",
      // should I include Data collection cycle and Cycle of activity for each student outcome tables?
      //the mapping array should follow the following format:
      PLOs_courses_mapping: [
        {
          id: "3.1",
          PLO: "3.1 Complex Eng. problem",
          EGR1010: true,
          EGR1015: "Oral & written",
          EGR1011: false,
        },
        {
          id: "3.2",
          PLO: "3.2 Eng. Design",
          1010: "Oral",
          1015: true,
          1011: "Graphical, oral & written",
        },
      ],
      // the courses array should include only the course codes [1010, 1015, 1011]
      courses: ["EGR1010", "EGR1015", "EGR1011"],
      // each PLO object should include the PLO's id code, name , target (expected level of attainment), the results of its evaluation
      PLOs: [
        {
          id: "3.1",
          code: "3.1",
          name: "1.  an ability to identify, formulate, and solve complex engineering problems by applying principles of engineering, science, and mathematics",
          target: "85%",

          // Results for each PLO evaluation are reported separately in tables.
          // Each PLO table includes performance indicators, courses and/or co-curricular activities (educational strategies) that provide students an opportunity to demonstrate the indicator, where summative data are collected, timetable, method of assessment and the performance target.
          // for each PLO table get the following information in the following format:
          evaluationTable: [
            {
              // the following is the performance indicator id:
              id: "3.1.1",
              performanceIndicator:
                "Problem statement shows understanding of the problem",
              EducationalStrategies: [
                "EGR 1010",
                "EGR 1015",
                "EGR 1011",
                "EGR 4090",
              ], //courses
              MethodsOfAssessment: [
                "Faculty assessment of design problem statement",
                "Senior Survey",
              ],
              // I am not sure about what it is meant by the following field:
              WhereSummativeDataAreCollected: ["EGR 4090", "On-line survey"],
              LengthOfAssessmentCycle: "3 years",
              YearSemesterOfDataCollection: "2018, 2021",
              TargetForPerformance: "85%",
            },
            {
              // the following is the performance indicator id:
              id: "3.1.2",
              performanceIndicator:
                "Problem solution is appropriate and within reasonable constraints",
              EducationalStrategies: [
                "EGR 1010",
                "EGR 1015",
                "EGR 1011",
                "EGR 4090",
              ], //courses
              MethodsOfAssessment: [
                "Faculty assessment of design problem statement",
                "Senior Survey",
              ],
              // I am not sure about what it is meant by the following field:
              WhereSummativeDataAreCollected: ["EGR 4090", "On-line survey"],
              LengthOfAssessmentCycle: "3 years",
              YearSemesterOfDataCollection: "2018, 2021",
              TargetForPerformance: "85%",
            },
          ],
          barChart: [
            {
              name: "Problem statement shows understanding of the problem",
              target: 90,
              2015: 80,
              2018: 85,
              2021: 90,
            },
            {
              name: "Problem solution is appropriate and within reasonable constraints",
              target: 90,
              2015: 80,
              2018: 85,
              2021: 90,
            },
          ],
          evaluationResults: `For summative assessment (end of program), the decision was made to
            focus on the direct assessment for all indicators. Summative data
            for Indicators #1 were collected in the Engineering Design I course
            (EGR 4090) where students are asked to develop their statement of
            the problem and project planning documentation. For Indicator #2 the
            assessment was completed in the second semester design course (EGR
            4092) as a part of the final assessment of the course. For Indicator
            #3 faculty created an examination administered in EGR 3030 which
            required students to apply mathematical principles to model
            equations to achieve solutions. For Indicator #4 the assessment was
            completed in the second semester design course (EGR 4092) as a part
            of the final assessment of student performance on the senior project
            report using a rubric for the indicator.`,
        },
        {
          id: "3.2",
          code: "3.2",
          name: "2.   an ability to apply engineering design to produce solutions that meet specified needs with consideration of public health, safety, and welfare, as well as global, cultural, social, environmental, and economic factors",
          target: "85%",

          // Results for each PLO evaluation are reported separately in tables.
          // Each PLO table includes performance indicators, courses and/or co-curricular activities (educational strategies) that provide students an opportunity to demonstrate the indicator, where summative data are collected, timetable, method of assessment and the performance target.
          // for each PLO table get the following information in the following format:
          evaluationTable: [
            {
              // the following is the performance indicator id:
              id: "3.2.1",
              performanceIndicator:
                "Produces a clear and unambiguous needs statement in a design project",
              EducationalStrategies: [
                "EGR 1010",
                "EGR 1015",
                "EGR 1011",
                "EGR 4090",
              ], //courses
              MethodsOfAssessment: [
                "Faculty assessment of design problem statement",
                "Senior Survey",
              ],
              // I am not sure about what it is meant by the following field:
              WhereSummativeDataAreCollected: ["EGR 4090", "On-line survey"],
              LengthOfAssessmentCycle: "3 years",
              YearSemesterOfDataCollection: "2018, 2021",
              TargetForPerformance: "85%",
            },
            {
              // the following is the performance indicator id:
              id: "3.2.2",
              performanceIndicator:
                "Identifies constraints on the design problem, and establishes criteria for acceptability and desirability of solutions",
              EducationalStrategies: [
                "EGR 1010",
                "EGR 1015",
                "EGR 1011",
                "EGR 4090",
              ], //courses
              MethodsOfAssessment: [
                "Faculty assessment of design problem statement",
                "Senior Survey",
              ],
              // I am not sure about what it is meant by the following field:
              WhereSummativeDataAreCollected: ["EGR 4090", "On-line survey"],
              LengthOfAssessmentCycle: "3 years",
              YearSemesterOfDataCollection: "2018, 2021",
              TargetForPerformance: "85%",
            },
          ],
          barChart: [
            {
              name: "Produces a clear and unambiguous needs statement in a design project",
              2015: 80,
              2018: 85,
              2021: 90,
            },
            {
              name: "Identifies constraints on the design problem, and establishes criteria for acceptability and desirability of solutions",
              2015: 80,
              2018: 85,
              2021: 90,
            },
          ],
          evaluationResults: `For the summative assessment (end of program), the decision was made to focus on the faculty’s direct assessment for all indicators.  Summative data for Indicators #1 and #2 were collected in the Engineering Design I (EGR4090) course. For Indicator #3 and Indicator #4 data were taken in the second semester design sequence (EGR4092) where the design project was completed. The scoring rubrics to assess student performance in both courses were completed by the faculty. The percent of the students that demonstrated each criterion were as follows:  Indicator #1 - 82%; Indicator #2 - 88% and Indicator #3-90%; and Indicator #4-89%.`,
        },
      ],
      description: `<p>The assessment of student outcomes is done on a three-year cycle, and thus twice within an ABET cycle. </p>`,
    },

    ContinuousImprovement: {
      description: `<p>This information is included in each outcome table. </p>`,
    },
    AdditionalInformation: {
      description: `<p>There will be a student outcomes notebook in the ABET resource room which will contain all assessment instruments and rubrics if they were used to assess the outcome.</p>`,
    },
    Analysis: {
      feedback: [
        {
          id: 1,
          subject: "Curriculum Breadth",
          descripton:
            "The curriculum provides strong coverage of core engineering concepts, but there is limited exposure to emerging technologies such as artificial intelligence and data analytics, which are increasingly important in modern engineering practice.",
          type: "concern",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "1",
              feedbackId: "1",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "2",
              feedbackId: "1",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "3",
              feedbackId: "1",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 2,
          subject: "Outcomes Assessment",
          descripton:
            "The program has not adequately demonstrated a structured and comprehensive approach to assessing student outcomes. There is no clear evidence that student performance is systematically evaluated against the stated program outcomes.",
          type: "deficiency",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "4",
              feedbackId: "2",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "5",
              feedbackId: "2",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "6",
              feedbackId: "2",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 3,
          subject: "Advising and Mentorship",
          descripton:
            "While academic advising is available, there is a weakness in the advising process, as students have expressed concerns about the lack of personalized guidance and mentorship to help them navigate their academic and career pathways.",
          type: "weakness",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "7",
              feedbackId: "3",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "8",
              feedbackId: "3",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "9",
              feedbackId: "3",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 4,
          subject: "Strong Industry Partnerships",
          descripton:
            "The program has established strong partnerships with local industries, offering students valuable internship opportunities and industry-sponsored projects that enhance their professional readiness.",
          type: "strength",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          //feedback of type strength does not have actions associated with it
          actions: [],
        },
        {
          id: 5,
          subject: "Expand Emerging Technology Offerings",
          descripton:
            "To keep pace with industry trends, the program should consider introducing electives or modules focused on emerging areas such as artificial intelligence, robotics, and renewable energy.",
          type: "recommendation for improvement",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "13",
              feedbackId: "5",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "14",
              feedbackId: "5",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "15",
              feedbackId: "5",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
      ],
    },
  },
  CRITERION5_CURRICULUM: {
    ProgramCurriculum: {
      //If there is more than one curricular path or option for a program, a separate programCurriculumTable should be provided for each path or option.
      programCurriculumTable: [
        {
          id: "1",
          title: "EGR 2015 Computing Tools of Engineers",
          // courseCode: "2015",
          // courseTitle: "Computing Tools of Engineers",
          // departmentName: "EGR",
          prerequisites: "None",
          corequisites: "None",
          mathBasicSciencesCredits: "10",
          engineeringTopicsCredits: "3",
          otherCredits: "5",
          credits: "14",
          type: "SE",
          courseLastTwoTerms: ["Fall 2024", "Fall 2025"],
          maximumSectionEnrollment: 100,
          yearTerm: "Freshman/fall",
        },
        {
          id: "2",
          title: "MTH 3030 Applied Math",
          prerequisites: "None",
          corequisites: "None",
          mathBasicSciencesCredits: "10",
          engineeringTopicsCredits: "3",
          otherCredits: "5",
          credits: "14",
          type: "SE",
          courseLastTwoTerms: ["Fall 2024", "Fall 2025"],
          maximumSectionEnrollment: 100,
          yearTerm: "Freshman/fall",
        },
      ],
      description: `<p>The curriculum for the Engineering program at Upper State University has been designed by the faculty to produce a graduate broadly acquainted with tools and principles that would be used in the engineering field.  While designed to develop the essential knowledge, skills, and abilities needed for professional practice or graduate study, the curricular structure of the program, coupled with the integrated influence of liberal arts studies, equips our students with a holistic educational experience that is designed to prepare students to succeed in a world characterized by rapidly developing technology, growing complexity, and globalization. The curriculum aligns with the program educational objectives through its direct support of the student outcomes.  Student outcomes map directly into program educational objectives.</p>
      <br></br><p>The Upper State University Engineering curriculum builds from basic to advanced courses, has a logical prerequisite tree, and balances semester loads among various technical and general education courses. All students take a common engineering core and then “invest” their elective engineering courses in one of four options, civil, chemical, electrical, or mechanical engineering.</p>`,
    },
    CourseSyllabi: {},
    Analysis: {},
  },
  CRITERION6_FACULTY: {
    FacultyQualifications: {
      description: `<p>Faculty members come from a wide variety of backgrounds and bring experience from education, research, and industry. Several faculty members are currently consultants with industry. All but the adjunct faculty hold earned Ph.D. degrees. Eight of the faculty members have significant industrial experience, and nine are active with sponsored research programs. All faculty members are members of at least one professional society related to engineering. Drs. Young and Zanzibar are the most recent hires (Fall, 2018). They will be participating in the National Effectiveness in Teaching Institute (NETI) workshop in the coming year. All faculty members with civil engineering backgrounds are registered professional engineers, as are four other faculty members.
      </p><br></br><p>Given the university’s emphasis on serving the world-wide community, the diversity of the faculty is a strength of our program.  Faculty members represent several different countries and nationalities, thus strengthening the global perspective of the program.  All Engineering faculty members possess excellent oral and written communication skills. These attributes are considered in the hiring process.</p>`,
      FacultyQualificationsTable: [
        {
          id: "1",
          name: "Dr. John Doe",
          degree: "Ph.D. (2003)",
          rank: "AST",
          AcademicAppointmentType: "TT",
          employmentStatus: "FT",
          nonAcademiaExperienceYears: "1",
          academiaExperienceYears: "11",
          insideInstitutionExperienceYears: "2",
          ProfessionalRegistrationCertification: "PE (VA)",
          ProfessionalOrganizationsActivityLevel: "H",
          ProfessionalDevelopmentActivityLevel: "M",
          industryConsultingORSummerWorkActivityLevel: "L",
        },
        {
          id: "2",
          name: "Dr. Robert Armstrong",
          degree: "Ph.D. (2003)",
          rank: "AST",
          AcademicAppointmentType: "TT",
          employmentStatus: "FT",
          nonAcademiaExperienceYears: "1",
          academiaExperienceYears: "11",
          insideInstitutionExperienceYears: "2",
          ProfessionalRegistrationCertification: "PE (VA)",
          ProfessionalOrganizationsActivityLevel: "H",
          ProfessionalDevelopmentActivityLevel: "M",
          industryConsultingORSummerWorkActivityLevel: "L",
        },
      ],
    },
    FacultyWorkload: {
      FacultyWorkloadTable: [
        {
          id: "1",
          name: "Dr. John Doe",
          employmentStatus: "FT",
          // classes For the academic year for which the self-study is being prepared.
          classes: [
            "EGR 3050 (3) SP/19",
            "EGR 3030 (3) F/19 & SP/20",
            "EGR 3020 (3) SP/19 & SP/20",
          ],
          teachingActivitiesPercentage: "60%",
          researchOrScholarshipActivitiesPercentage: "10%",
          otherActivitiesPercentage: "30%",
          timePercentageDevotedToTheProgram: "100%",
        },
        {
          id: "2",
          name: "Dr. Robert Armstrong",
          employmentStatus: "FT",
          classes: [
            "EGR 3050 (3) SP/19",
            "EGR 3030 (3) F/19 & SP/20",
            "EGR 3020 (3) SP/19 & SP/20",
          ],
          teachingActivitiesPercentage: "60%",
          researchOrScholarshipActivitiesPercentage: "10%",
          otherActivitiesPercentage: "30%",
          timePercentageDevotedToTheProgram: "100%",
        },
      ],
      description: `<p>The normal teaching load is two courses per semester. The program chairperson teaches one course per semester.</p>`,
    },
    FacultySize: {
      description: `<p>Since the last ABET visit, the number of faculty members in Engineering has grown. Eight new faculty members all with full-time appointments in Engineering have been hired. The Engineering faculty is sufficient to cover all of the required EGR courses and each of the elective courses, with at least two faculty members capable of teaching each course.</p><p><br></p><table style="width: initial;"><tbody><tr><td style="width: 204px;"><p data-cellwidth="204px">Faculty Member</p><p data-cellwidth="204px"><br></p></td><td style="width: 204px;"><p data-cellwidth="204px">Competency Area</p><p data-cellwidth="204px"><br></p></td></tr><tr><td style="width: 204px;"><p data-cellwidth="204px">Begone</p></td><td style="width: 204px;"><p data-cellwidth="204px">Civil</p></td></tr><tr><td style="width: 204px;"><p data-cellwidth="204px">Aloevera*</p></td><td style="width: 204px;"><p data-cellwidth="204px">Mechanical</p></td></tr><tr><td style="width: 204px;"><p data-cellwidth="204px">Activeeti</p></td><td style="width: 204px;"><p data-cellwidth="204px">Chemical</p></td></tr></tbody></table><p><br></p><p>Ten adjunct faculty members from local industry are available to help with teaching responsibilities. All of the core courses are offered at least once a year, and all of the elective courses are offered once a year. Some of the EGR courses are offered in the summer to accommodate cooperative education and internship students.</p><p><br></p><p><strong><u>Interactions with Students, Student Advising and Counseling.</u></strong> As described in Criterion 1, full- time academic advisors conduct the majority of student advising. However, faculty interact closely with students in career decisions and advising, they direct independent research students, and employ NSF Undergraduate Research, minority and other undergraduate research students in their laboratories. Program faculty members also advise very active student chapters of the professional societies (ASCE, ASME, AIChE, IEEE). All faculty members maintain an open-door policy for student office hours and consultation.</p><p><br></p><p><strong><u>University Service.</u></strong> Program service activities are extensive. Our faculty members lead or participate in twelve college or university committees. A significant number of our faculty members are also involved in outreach programs to the local schools and communities. They participate through Upper State University sponsored activities (summer institutes, math and science camps, open house, job-shadowing activities, etc.) and through their own initiatives (math/science conferences for elementary school girls, other outreach programs in K-12 classrooms, science fair sponsorships).</p><p><br></p><p><strong><u>Professional Development.</u></strong> In addition to sponsored research and industrial consulting, our faculty members are active in professional society activities. Five are very active in ABET, serving as program evaluators or commissioners. Several lead divisions of their professional societies. Program faculty members chair two NIST committees.</p><p><br></p><p><strong><u>Interaction with Industry.</u></strong> Some of our faculty members consult for industry and are actively involved in proposal reviews and panels. Industrial representatives are frequently invited as guest lecturers in many of the undergraduate classes.</p><p><br></p>`,
    },
    ProfessionalDevelopment: {
      description: `<p>All Engineering faculty members are expected to maintain currency in their discipline through scholarly and professional development activities. Engineering faculty participate in a wide range of professional societies including ASCE, ASME, AIChE, IEEE, ASEE, and others. International study opportunities for undergraduate students have been provided by our faculty who have developed or facilitated exchange programs in Italy, England, Mexico, Australia, and Puerto Rico. All of our faculty members have participated in the workshops conducted by our Teaching &amp; Learning Center (TLC); some have even conducted these workshops. Others participate regularly in special workshops and conferences sponsored by such organizations as ASEE, NSF, ABET, and others. See the faculty resumes in Appendix B for more information on individual faculty members.</p><p><br></p><p>Since professional development is required for faculty tenure and promotion decisions, faculty members are assisted and encouraged in these activities with an annual, individual professional development fund. The amount has varied over the past six years but has generally fallen between $1500 and $2000 annually. The funding is provided by the university. In addition, many faculty members have funded research programs, in which they involve undergraduate researchers. See the faculty resumes in Appendix B for the professional development activities for each faculty member.</p><p><br></p><p>Faculty evaluations are based on how each faculty member supports the educational mission of the program, the college, and the university. As required by the Upper State University Faculty Handbook, evaluations are conducted annually in the following ways:</p><p><br></p><p><strong><u>Teaching Portfolio:</u></strong> Each faculty member assembles a teaching portfolio that includes examples of student work, records of assessment, and retrospective analysis of means of improvement. Student evaluations are also included in the record as are, when appropriate, special awards and student letters.</p><p><br></p><p><strong><u>Review of teaching by The Teaching and Learning Center:</u></strong> Each faculty member is required to conduct a conference with a TLC consultant every three years. The consultant conducts a direct classroom observation and then discusses his/her observations with the faculty member. If suggestions for improvement are made, the teaching portfolio includes this information and the tracking of how attempts at improvement were made.</p><p><br></p><p><strong><u>Annual Review:</u></strong> Each faculty member completes an annual report on all university activities— teaching, research, and service. The format is prescribed, and the teaching portfolio is also included in this package. The chairperson discusses the annual report with each faculty member and uses the review to make decisions on merit-pay changes.</p><p><br></p>`,
    },
    AuthorityAndResponsibilityOfFaculty: {
      description: `<p>All program changes originate in the Engineering Curriculum Committee. The program faculty approves changes and forwards them to the College Curriculum Committee. All changes must originate in the program. The program faculty is responsible for evaluating the program. Some assistance is obtained from the Office of Instructional Technology to maintain our web-based surveys. All EGR courses are taught by full-time faculty members in the program.</p>`,
    },
    Analysis: {
      feedback: [
        {
          id: 1,
          subject: "Curriculum Breadth",
          descripton:
            "The curriculum provides strong coverage of core engineering concepts, but there is limited exposure to emerging technologies such as artificial intelligence and data analytics, which are increasingly important in modern engineering practice.",
          type: "concern",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "1",
              feedbackId: "1",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "2",
              feedbackId: "1",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "3",
              feedbackId: "1",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 2,
          subject: "Outcomes Assessment",
          descripton:
            "The program has not adequately demonstrated a structured and comprehensive approach to assessing student outcomes. There is no clear evidence that student performance is systematically evaluated against the stated program outcomes.",
          type: "deficiency",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "4",
              feedbackId: "2",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "5",
              feedbackId: "2",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "6",
              feedbackId: "2",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 3,
          subject: "Advising and Mentorship",
          descripton:
            "While academic advising is available, there is a weakness in the advising process, as students have expressed concerns about the lack of personalized guidance and mentorship to help them navigate their academic and career pathways.",
          type: "weakness",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "7",
              feedbackId: "3",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "8",
              feedbackId: "3",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "9",
              feedbackId: "3",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 4,
          subject: "Strong Industry Partnerships",
          descripton:
            "The program has established strong partnerships with local industries, offering students valuable internship opportunities and industry-sponsored projects that enhance their professional readiness.",
          type: "strength",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          //feedback of type strength does not have actions associated with it
          actions: [],
        },
        {
          id: 5,
          subject: "Expand Emerging Technology Offerings",
          descripton:
            "To keep pace with industry trends, the program should consider introducing electives or modules focused on emerging areas such as artificial intelligence, robotics, and renewable energy.",
          type: "recommendation for improvement",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "13",
              feedbackId: "5",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "14",
              feedbackId: "5",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "15",
              feedbackId: "5",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
      ],
    },
  },
  CRITERION7_FACILITIES: {
    OfficesClassroomsLaboratories: {
      description: `<p>Each faculty member has a private office that is approximately 10’x10’. The office equipment includes standard desk, chair, bookcases, small table and two chairs for meeting with students. Each faculty member has a workstation, printer, and laptop with network and local printer access.</p><p><br></p><p>All Engineering classes are held in the Natural Sciences Building. All classrooms are equipped with projectors for computer-based material as well as with whiteboards and document cameras. Network access is available in all classrooms as well. Laptop computers are available to faculty if needed, but faculty members normally use their own laptops for this purpose. The classrooms are adequate for the needs of the program. The classroom technology is supported by the Office of Instructional Technology (OIT—please see Criterion 8).</p><p><br></p><p>The program operates four teaching laboratories (two electronics laboratories, a fluid mechanics laboratory, and a materials science laboratory) and two general-purpose laboratories. The two electronics laboratories, the fluid mechanics lab, and the materials science lab have appropriate equipment and analysis devices including oscilloscopes, circuit design kits, wave form generators, balances, testing equipment, hardness and tensile testing machines, an electron microscope, wind tunnels, a viscometer, flow meters, pumps, pool devices, and valves. Laboratories in the options have heat exchangers, a distillation column, a countercurrent heat exchanger, control systems, universal testing equipment, various sieves, hydrometer analysis equipment, refrigeration systems, analytical balances, an autoclave, a fuel cell, and a fermenter. The necessary glassware and analysis equipment are available in a centralized supplies storage room. Safety equipment is inspected and up to date.</p><p><br></p><p>The two rooms used for computer courses have 30 networked Windows-based student stations and one instructor station in one, and 45 networked Windows-based computers and an instructor station in the other. All software needed for basic course work is installed on all computers. Both rooms have a ceiling-mounted computer projector and projection screens.</p>`,
    },
    ComputingResources: {
      description: `<p>The university Office of Computing and Communication Technology (CCT) operates ten computing laboratories for the benefit of all USU students. These laboratories contain Windows-based computers with a standard set of basic software, plus printers and scanners. All computers are connected to the CCT network, which allows high-speed access to the internet. CCT also provides high-speed computing facilities, including access to both local (medium scale) and regional supercomputing facilities for approved users.</p><p><br></p><p>The Office of Instructional Technology (OIT) licenses many of the current software packages that are used extensively throughout the curriculum, including MATLAB, MathCAD, CADCAM, ASPEN, NX Unigraphics, Fluent, PCSpice, Spark Toolkit 7.1, and others. Faculty requests for additional software purchases are granted regularly with appropriate justification.</p><p><br></p><p>The Engineering program computing facilities are available from 7 am until midnight Monday- Thursday, 7 am until 6 pm Friday, 9 am until 6 pm Saturday, and noon until midnight on Sunday. Most students have laptops or residence computers, and they can access course management software and perform many remote operations 24/7. There have been no complaints from the students concerning access or support.</p><p><br></p><p>Each faculty member has a desktop workstation (Windows, or Mac, as preferred), a printer and a laptop. There also is a high-speed printer and a scanner near the faculty office area that is on the local network. This is sufficient to support the scholarly and professional activities of the faculty.</p>`,
    },
    Guidance: {
      description: `<p>Each student working in a university laboratory must attend a safety seminar once a year and pass the safety exam based on the seminar. The safety seminar covers safe work practices, good laboratory practices, personal protective equipment, safety equipment, electrical safety, chemical safety, waste handling, and emergency evacuation. Students are provided demonstrations of specific equipment by qualified technical staff or faculty prior to performing laboratory work. Qualified technical staff or faculty must be present at all times that students are in the laboratory; students are not allowed to work alone in any laboratories.</p><p><br></p>`,
    },
    MaintenanceAndUpgradingOfFacilities: {
      description: `<p>The 1960s Engineering Building was renovated in 1986 and again in 2004-2005 to include major modernization of all classrooms and student laboratories. The building has twenty classrooms, ten laboratories, and one large auditorium. Part of a $100/semester student fee is dedicated to computer and laboratory modernization. The classroom technology is updated every three years or as needed. Over the past several years, the funds have been used mainly for computer upgrading and installation and subsequent upgrading of a wireless network in the building.</p><p>Computing hardware in the program labs and offices is replaced according to a schedule, with a maximum replacement cycle of three years for computing equipment. Major software upgrades are made on a schedule determined by the ascertained stability of the new software and the academic calendar (avoiding major upgrades during an academic term). Software upgrades to repair faults are installed as soon as feasible after they are released. The replacement plan for the hardware and software in the program’s laboratories is included in Appendix C.</p><p>New hardware and software are purchased as needed to support the program within the normal budget process. If the regular program budget will not support the acquisition, then a request is made during the next normal annual budget process. Emergency funds for short-term repairs may be made as a special request to the dean’s office.</p><p>In general, the program has been able to develop and maintain good labs to support the program. The need for additional equipment or upgrades is determined from student and faculty feedback and during planning for new or modified courses.</p><p>The program has one full-time technician for laboratory support, and he also has six student assistants who provide support. The level of support is, in general, better than adequate, although as in any academic setting there may be times, such as the first and final weeks of a semester, when there is more work to be done than can be completed as quickly as desired.</p><p><br></p>`,
    },
    LibraryServices: {
      description: `<p>The Engineering and Technology library is in a facility shared with the Natural Science library. The library contains at least one copy of every textbook used in ET courses, plus an excellent collection of classical and standard texts in various areas of engineering. The library subscribes to the print versions of the full set of publications from the ASCE, ASME, AIChE and IEEE. There also are several electronic subscriptions. Requests for additional publications are submitted to the library liaison, and the annual budget for engineering publications acquisition is adequate to maintain an up-to-date collection.</p><p><br></p><p>The catalog of library resources is online and accessible from the university computing network to university employees and students. In addition to several electronic repositories of publications, there also are search engines that identify resources that are available from a variety of sources.</p><p><br></p><p>The library is a member of state and regional consortia for sharing resources. Print material that is not available locally normally can be obtained through inter-library loan within one or two days.</p><p><br></p>`,
    },
    OverallCommentsOnFacilities: {
      description: `<p>The Upper State University Office of Physical Plant performs annual safety audits of each building. The audits include offices, classrooms, laboratories, storage and shipping areas, and building utilities (electricity, water, sewer, heat/ac, elevators, fire, etc.). Each program must maintain records of maintenance and calibration of equipment owned by and used by the program. This includes office equipment (copiers, fax machines, scanners, and printers) and laboratory equipment. The Engineering program administrative assistant and laboratory technician are responsible for maintaining this documentation. Deficiencies found with respect to the building and utilities are the responsibility of the Office of Physical Plant; deficiencies found with respect to program equipment are the responsibility of the program. Level 1 deficiencies must be addressed within 7 days; level 2 within 30 days; and level 3 within 180 days.</p><p><br></p><p>To ensure Engineering laboratories are safe, the program laboratory technician performs random safety audits of each laboratory throughout each semester. Reports are provided to the responsible faculty member with a copy to the program chairperson.</p><p><br></p>`,
    },
    Analysis: {
      feedback: [
        {
          id: 1,
          subject: "Curriculum Breadth",
          descripton:
            "The curriculum provides strong coverage of core engineering concepts, but there is limited exposure to emerging technologies such as artificial intelligence and data analytics, which are increasingly important in modern engineering practice.",
          type: "concern",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "1",
              feedbackId: "1",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "2",
              feedbackId: "1",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "3",
              feedbackId: "1",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 2,
          subject: "Outcomes Assessment",
          descripton:
            "The program has not adequately demonstrated a structured and comprehensive approach to assessing student outcomes. There is no clear evidence that student performance is systematically evaluated against the stated program outcomes.",
          type: "deficiency",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "4",
              feedbackId: "2",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "5",
              feedbackId: "2",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "6",
              feedbackId: "2",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 3,
          subject: "Advising and Mentorship",
          descripton:
            "While academic advising is available, there is a weakness in the advising process, as students have expressed concerns about the lack of personalized guidance and mentorship to help them navigate their academic and career pathways.",
          type: "weakness",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "7",
              feedbackId: "3",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "8",
              feedbackId: "3",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "9",
              feedbackId: "3",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 4,
          subject: "Strong Industry Partnerships",
          descripton:
            "The program has established strong partnerships with local industries, offering students valuable internship opportunities and industry-sponsored projects that enhance their professional readiness.",
          type: "strength",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          //feedback of type strength does not have actions associated with it
          actions: [],
        },
        {
          id: 5,
          subject: "Expand Emerging Technology Offerings",
          descripton:
            "To keep pace with industry trends, the program should consider introducing electives or modules focused on emerging areas such as artificial intelligence, robotics, and renewable energy.",
          type: "recommendation for improvement",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "13",
              feedbackId: "5",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "14",
              feedbackId: "5",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "15",
              feedbackId: "5",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
      ],
    },
  },
  CRITERION8_INSTITUTIONALSUPPORT: {
    Leadership: {
      description: `<p>As described earlier, the program is part of the College of Natural Science and Engineering. The responsibility for leadership of the program lies with the program chairperson, Dr. Aloevera. Dr. Alovera has been chairperson for one year. Prior to that Dr. Seement served as interim chairperson for two years while the search for a chairperson was being conducted. The previous chairperson, Dr. Geek, left the university after serving as chair from 2016-18.</p><p><br></p><p>The chairperson is supported by an administrative assistant, an accounting technician, and student workers for reception service and general assistance during normal office hours. The program chairperson has a 50% reduction in normal teaching load. Student records and other general student services are provided by the dean’s office as well as some general assistance and coordination for administrative functions.</p><p><br></p><p>The Engineering Curriculum Committee is responsible for identifying improvements to the curriculum. The Committee meets at least once a semester to review assessment results of the previous semester and to recommend improvements to the curriculum. All recommendations for changing program educational objectives, student outcomes, or courses are considered by and voted upon by all full-time faculty members.  The approved changes are then forwarded to the College Curriculum Committee for review and approval before going to the Provost.</p><p><br></p><p>The Dean of the College of Natural Science and Engineering, Dr. Deanly, is responsible for all faculty hiring, budget allocations, and policy matters within the College. As the chief academic officer of the university, the Provost has the final approval of academic actions as the final step of the required academic governance and approval process. Except when over-riding budgetary restrictions have been in place, historically all academic and curricular proposals from Engineering have been approved by the Provost.</p><p><br></p>`,
    },
    ProgramBudgetAndFinancialSupport: {
      description: `<p>Upper State University and its academic colleges operate on a fiscal year dating from July 1 to June 30. The college and all of its programs use a “zero-based budget” concept. The three main flows of college support for undergraduate education are based on 1) the size of faculty, 2) the educational programs and number of students in the programs (largely return of student fee money), and 3) special allocations for updating laboratories and computing facilities. The third item, not part of the zero-based process, is an annual budgeting item that is part of Planning and Program Review (PPR) process. This allocation comes directly from the university. Other cash flows include return of overhead and special allocations for faculty hiring.</p><p><br></p><p>In the spring of each year the dean prepares a document called the Planning and Program Review (PPR) document which describes and justifies the college’s request for new funds, both for recurring expenses and one-time expenses. The dean is not required to justify the existing base budget; the PPR process is essentially focused on new funds. The request is submitted to the Provost of the University.</p><p><br></p><p>In late spring or early summer, the college and program budgets are finalized for the following year. This budgeting approach facilitates identification and prioritization of requirements and allocation of resources. The engineering program has had good success in obtaining funds for undergraduate laboratory upgrades, computer facilities for faculty, and start-up requests for new faculty.</p><p><br></p><p>Each Engineering course is supported by a half-time teaching assistant and a grader. The exception to this is the seminar courses, which do not have a teaching assistant or a grader. In lieu of these, faculty members who teach seminar courses are provided with office staff assistance for managing student work and grade entry. Laboratory courses have one teaching assistant per laboratory section for the purpose of laboratory safety and guidance.</p><p><br></p><p>The buildings, offices, and other infrastructure are maintained as part of the University’s maintenance plan and is managed at the University level.</p><p><br></p><p>Laboratory budget requests are submitted by program faculty with responsibilities for the laboratories on an annual basis as part of the PPR process. Emergency funds for short-term repairs are provided by the dean’s office. These “emergency” funds vary in amount up to</p><p>$1000. Each student pays a $100 laboratory fee each semester, and these funds are used to support acquisition and maintenance of laboratory facilities and equipment.</p><p><br></p><p>Upper State University has a long and solid history of strength in undergraduate education, which will continue to be emphasized as a hallmark of our institution by the current administration. The level of support has enabled undergraduate instruction to remain an important element of faculty responsibilities. Sufficient funds have been provided for support of teaching assistants, program staff, facilities, and equipment.</p>`,
    },
    Staffing: {
      description: `<p><em>Program Staff</em>. The Engineering program has excellent support personnel.  An office supervisor, five office staff members, and five part-time undergraduates effectively support the faculty and the Engineering program. One full-time technician is charged with maintaining the equipment in all of the common labs (excluding the labs operated by CCT) and works under the direct supervision of the program chairperson. Upper State University has competitive salaries and benefits. There have not been any problems attracting or retaining program staff over the last five years.</p><p><br></p><p><em>Advising</em>. Most undergraduate advising for course selection is done by the professional advising staff. The Office of the Associate Dean for Undergraduate Studies in the College of Natural Sciences and Engineering (CNSE) provide strong support for student monitoring and advising activities.</p><p><br></p><p><em>Institution Support Staff</em>. The Office of Instructional Technology (OIT) supports faculty computing activities. Staff members associated with OIT also support program assessment through the installation and maintenance of our web-based surveys.</p><p><br></p><p>Student job placement activities are supported by Ms. Sophie Brown, a Career Services Field Consultant. She frequently presents workshops in resume-writing, interviewing, and consults regularly with students conducting job searches. Ms. Brown is also a frequent presenter in the seminar courses. The Career Services and Placement office operates at the university level and provides a broad spectrum of career advising and career exploration services. Ms. Brown is our local contact to that office.</p><p><br></p><p>The Cooperative Education and Internships program is administered and coordinated by Dr. Georgia Atlanta. Dr. Atlanta interacts directly with the students and employers involved in the co-op program for the entire college. Her office also coordinates annual college career fairs.</p><p><br></p><p>In summary, excellence in undergraduate instructions and modern facilities enable student learning and their achievement of good levels of performance in all of the student outcome areas. This further enables them to achieve the program educational objectives once they graduate. The feedback we have obtained thus far demonstrates that the engineering administration, faculty, staff, and students have been successful in this area.</p>`,
    },
    FacultyHiringAndRetention: {
      description: `<p>Upper State University has competitive salaries and benefits, and a standard sabbatical program. There have not been any problems attracting or retaining faculty over the last five years.</p><p><br></p><p><strong>Process for Hiring New Faculty</strong></p><p>The Dean of the College of Natural Sciences and Engineering is responsible for the staffing of all teaching and research positions within the approved budget of the College. National advertising is required for all tenure-track or tenured faculty positions. The Dean appoints a search committee for each open tenure-track or tenured faculty position. The majority of members of the search committee are from the program. Faculty members from other programs within the College, administrators, staff, and students may be included on the search committee as appropriate. The search committee’s charge is to identify, screen, and interview qualified candidates. The search committee presents its recommendation to the Dean, who will choose from the candidates and make an offer of employment.</p><p><br></p><p><strong>Strategies to Retain Current Qualified Faculty</strong></p><p>Upper State University believes the faculty is the heart of a strong undergraduate program and seeks to retain all qualified faculty through professional development, a transparent tenure and promotion process, a sabbatical program, administrative support staff and student graders, attractive facilities, and competitive benefits (health and life insurance, retirement planning, etc.).</p><p><br></p>`,
    },
    SupportOfFacultyProfessionalDevelopment: {
      description: `<p>There is travel support for each faculty member to attend one professional meeting each year. Additional support can be requested for travel to present a paper at a professional meeting. Course-release buyouts are possible from grant funds. The department has averaged one conference paper each year per faculty member and one journal paper every two years.</p><p><br></p><p>Most planning for professional development occurs during the annual review process during the early spring of each year. At this time the individual faculty members and the dean agree on activities that will be emphasized during the upcoming year. Depending on the needs and availability of funds, the dean also commits resources. At the following year’s annual review, an accounting for results based on mutual commitments made at the previous annual review is held between the dean and the faculty member.</p><p><br></p>`,
    },
    Analysis: {
      feedback: [
        {
          id: 1,
          subject: "Curriculum Breadth",
          descripton:
            "The curriculum provides strong coverage of core engineering concepts, but there is limited exposure to emerging technologies such as artificial intelligence and data analytics, which are increasingly important in modern engineering practice.",
          type: "concern",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "1",
              feedbackId: "1",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "2",
              feedbackId: "1",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "3",
              feedbackId: "1",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 2,
          subject: "Outcomes Assessment",
          descripton:
            "The program has not adequately demonstrated a structured and comprehensive approach to assessing student outcomes. There is no clear evidence that student performance is systematically evaluated against the stated program outcomes.",
          type: "deficiency",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "4",
              feedbackId: "2",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "5",
              feedbackId: "2",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "6",
              feedbackId: "2",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 3,
          subject: "Advising and Mentorship",
          descripton:
            "While academic advising is available, there is a weakness in the advising process, as students have expressed concerns about the lack of personalized guidance and mentorship to help them navigate their academic and career pathways.",
          type: "weakness",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "7",
              feedbackId: "3",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "8",
              feedbackId: "3",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "9",
              feedbackId: "3",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
        {
          id: 4,
          subject: "Strong Industry Partnerships",
          descripton:
            "The program has established strong partnerships with local industries, offering students valuable internship opportunities and industry-sponsored projects that enhance their professional readiness.",
          type: "strength",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          //feedback of type strength does not have actions associated with it
          actions: [],
        },
        {
          id: 5,
          subject: "Expand Emerging Technology Offerings",
          descripton:
            "To keep pace with industry trends, the program should consider introducing electives or modules focused on emerging areas such as artificial intelligence, robotics, and renewable energy.",
          type: "recommendation for improvement",
          assignees: [
            { name: "John", id: "1" },
            { name: "Jane", id: "2" },
          ],
          startdate: "01/01/2025",
          enddate: "12/3/2025",
          actions: [
            {
              id: "13",
              feedbackId: "5",
              subject: "action 1",
              descripton: "descripton action 1",
              date: "01/01/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "14",
              feedbackId: "5",
              subject: "action 2",
              descripton: "descripton action 2",
              date: "01/02/2025",
              assignees: [{ name: "John", id: "1" }],
            },
            {
              id: "15",
              feedbackId: "5",
              subject: "action 3",
              descripton: "descripton action 3",
              date: "01/05/2025",
              assignees: [{ name: "Jane", id: "2" }],
            },
          ],
        },
      ],
    },
  },
  AppendixA_CourseSyllabi: {},
  AppendixB_FacultyVitae: {},
  AppendixC_Equipment: {},
  AppendixD_InstitutionalSummary: {
    Institution: {
      institution: {
        name: "Upper State University",
        address: "Upper State, Anystate",
      },
      CEO: { name: "John Doe", title: "CEO" },
      SSRSubmitter: {
        name: "Jane Smith",
        title: "chairman of the academic quality committee",
      },
      accredition: {
        organazation: "ABET",
        initialAccreditationEvaluationDate: "01/01/2025",
        mostRecentAccreditationEvaluationDate: "01/01/2025",
      },
    },
    TypeOfControl: {
      description: ``,
    },
    EducationalUnit: {
      description: ``,
    },
    AcademicSupportUnits: {
      AcademicSupportUnits: [
        {
          unit: "Biology",
          responsible: {
            name: "Dr. Valerie Flora",
            title: "Chairperson",
          },
        },
        {
          unit: "Business",
          responsible: {
            name: "Dr. James Botline",
            title: "Dean",
          },
        },
        {
          unit: "Chemistry",
          responsible: {
            name: "Dr. Marcus Molecule",
            title: "Chairperson",
          },
        },
      ],
    },
    NonAcademicSupportUnits: {
      NonAcademicSupportUnits: [
        {
          unit: "Library",
          responsible: {
            name: "Dr. Valerie Flora",
            title: "Chairperson",
          },
        },
        {
          unit: "Admissions",
          responsible: {
            name: "Dr. James Botline",
            title: "Dean",
          },
        },
        {
          unit: "Career Services and Placement",
          responsible: {
            name: "Dr. Marcus Molecule",
            title: "Chairperson",
          },
        },
      ],
    },
    CreditUnit: {},
    Tables: {
      FacultyWorkloadTable: [
        {
          id: "1",
          name: "Dr. John Doe",
          employmentStatus: "FT",
          classes: [
            "EGR 3050 (3) SP/19",
            "EGR 3030 (3) F/19 & SP/20",
            "EGR 3020 (3) SP/19 & SP/20",
          ],
          teachingActivitiesPercentage: "60%",
          researchOrScholarshipActivitiesPercentage: "10%",
          otherActivitiesPercentage: "30%",
          timePercentageDevotedToTheProgram: "100%",
        },
        {
          id: "2",
          name: "Dr. Robert Armstrong",
          employmentStatus: "FT",
          classes: [
            "EGR 3050 (3) SP/19",
            "EGR 3030 (3) F/19 & SP/20",
            "EGR 3020 (3) SP/19 & SP/20",
          ],
          teachingActivitiesPercentage: "60%",
          researchOrScholarshipActivitiesPercentage: "10%",
          otherActivitiesPercentage: "30%",
          timePercentageDevotedToTheProgram: "100%",
        },
      ],
    },
  },
};

export default SSRSTRUCTURE;
